import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { httpAuthService } from '@commons';
import { path } from '@commons/path';
import { trackEvent } from 'mixpanel';
import { ZendeskAPI } from '../../../ZendeskConfig'

import blankProfile from '../../../assets/images/users/blank-profile-picture.png';

class ProfileMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            menu: !prevState.menu
        }));
    }


    render() {
        const { loginReducer } = this.props;

        return (
            <React.Fragment>
                <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block" >
                    <DropdownToggle className="btn header-item waves-effect" tag="button">
                        {/* <i className="mdi mdi-cowboy font-size-1 item-menu-color-intranet" style={{ marginRight: '5px' }} />
                        <span className="item-menu-color-intranet">{loginReducer.user.name.split(' ').shift()} {"  "}</span>
                        <i className="fa fa-angle-down item-menu-color-intranet" /> */}
                        <img className="rounded-circle header-profile-user" src={blankProfile} alt="Header Avatar" />
                    </DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem tag="a" href="/meuPerfil" onClick={() => trackEvent('Clicou no Profile Corporate Menu > Meu perfil')}>
                            <i className="mdi mdi-account-circle font-size-17 align-middle mr-1" />Meu perfil
                        </DropdownItem>
                        <hr />
                        <DropdownItem tag="a" href="/suporte" onClick={() => trackEvent('Clicou no Profile Corporate Menu > Central de Ajuda')}>
                            <i className="fa fa-headset font-size-17 align-middle mr-1" />Central de Ajuda
                        </DropdownItem>
                        <DropdownItem tag="a" href="https://forms.gle/pmP8qsG1MDYyLaCk8" target='_blank' onClick={() => trackEvent('Clicou no Profile Corporate Menu > Deixe seu Feedback')}>
                            <i className="mdi mdi-comment-question-outline font-size-17 align-middle mr-1" />Deixe seu Feedback
                        </DropdownItem>
                        <DropdownItem tag="a" href="https://forms.gle/zJtvoW8VJi89Vetp9" target='_blank' onClick={() => trackEvent('Clicou no Profile Corporate Menu > Sugira uma Funcionalidade')}>
                            <i className="mdi mdi-lightbulb font-size-17 align-middle mr-1" />Sugira uma Funcionalidade
                        </DropdownItem>
                        <DropdownItem tag="a" href="https://agrare.com.br/termos-de-uso" target='_blank' onClick={() => trackEvent('Clicou no Profile Corporate Menu > Termos de Uso')}>
                            <i className="mdi mdi-alert font-size-17 align-middle mr-1" />Termos de Uso
                        </DropdownItem>
                        <div className="dropdown-divider"></div>
                        <Link
                            to="/login"
                            onClick={() => {
                                trackEvent('Clicou no Profile Corporate Menu > Sair do Sistema')
                                httpAuthService.logout({ path });
                                document.body.classList.add('zendesk-hide');
                                ZendeskAPI('messenger', 'hide');
                            }}
                            className="dropdown-item">
                            <i className="mdi mdi-logout font-size-17 align-middle mr-1"></i>
                            <span>Sair do Sistema</span>
                        </Link>

                    </DropdownMenu>
                </Dropdown>
            </React.Fragment>
        );
    }
}

export function mapStateToProps(state) {
    const { loginReducer } = state.entities;
    return { loginReducer };
};

function mapDispatchToProps(dispatch) {
    return {}
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ProfileMenu))



